import { createAsyncThunk } from "@reduxjs/toolkit";
import NominationApi from "api/NominationApi";

export const fetchNomination = createAsyncThunk(
  "fetchNomination",
  ({ companyId }: { companyId: number }) =>
    NominationApi.fetchNomination(companyId)
);
